import { UI_TYPE } from './const';
import type { ITimezoneConfig } from '../../interface/ITimezone';

export const getParent = (config: ITimezoneConfig) => {
  const { parent, uiType } = config || {};
  return parent ?? (uiType === UI_TYPE.BTN_LAYER ? document.querySelector('.ncui-timezone') : document.querySelector('body'));
};

export const empty = (parent: Element) => {
  while(parent?.firstChild) {
    parent?.removeChild(parent?.firstChild);
  }
};